"use client";

import { useEffect, useState, type FC } from "react";

import { MobileChatAgentHeader, MobileChatFrame } from "@ui/components/core/BaseChat";
import { ChatScenario } from "@ui/components/core/ChatScenario";

import type { AccordionSlidesLazyAssetProps, ChatScenarioAccordionAsset } from "./AccordionSlidesShared";

export const AccordionSlidesAssetChatScenario: FC<
  AccordionSlidesLazyAssetProps & { asset: ChatScenarioAccordionAsset }
> = ({ asset, inView, isPreload }) => {
  const [playbackKey, setPlaybackKey] = useState(0);
  const [hasCompletedPlayback, setHasCompletedPlayback] = useState(false);

  const isActive = inView && !isPreload;

  useEffect(() => {
    setHasCompletedPlayback(false);
  }, [isActive, playbackKey]);

  const handleMouseEnter = () => {
    if (!isActive || !hasCompletedPlayback) {
      return;
    }

    setHasCompletedPlayback(false);
    setPlaybackKey(prev => prev + 1);
  };

  return (
    <div className='tw-aspect-[3/4] tw-w-full tw-rounded-lg sm:tw-aspect-square' onMouseEnter={handleMouseEnter}>
      <MobileChatFrame header={<MobileChatAgentHeader title={asset.agentName} />}>
        <ChatScenario
          key={playbackKey}
          active={isActive}
          anchor={asset.anchor}
          onComplete={() => setHasCompletedPlayback(true)}
          scenario={asset.scenario}
        />
      </MobileChatFrame>
    </div>
  );
};
